module.exports = __webpack_public_path__ + "static/media/connection-error.eae521dc.png";